import React from 'react';
import { format } from 'date-fns';
import { useDataHelper } from 'utils/dataHelper';

import { SdmTypography, SdmIconButtonLoader } from 'components';

import { styled } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import SecurityIcon from '@material-ui/icons/Security';
import { theme } from 'theme';

import CloseIcon from '@material-ui/icons/Close';

const MainContainer = styled('div')({
  display: 'flex',
});

const Filler = styled('div')({
  flexGrow: 1,
});

const MessageContainer = styled('div')(({ ismobile }) => ({
  marginTop: 8,
  maxWidth: ismobile ? '100%' : '70%',
  minWidth: 100,
  minHeight: 55,
  borderRadius: 10,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
}));

const MessageTextContainer = styled('div')(({ paddingleft }) => ({
  paddingLeft: paddingleft ? paddingleft : 0,
  display: 'flex',
  flexDirection: 'column',
}));

const InnerContainer = styled('div')({
  display: 'flex',
  paddingLeft: 10,
  paddingRight: 10,
});

const MessageTypography = styled(SdmTypography)(
  ({ externalmargin, overrideopacity, overridefontsize }) => ({
    fontSize: overridefontsize ? overridefontsize : 16,
    fontFamily: 'Suisse-Intl',
    margin: externalmargin != null ? externalmargin : 8,
    opacity: overrideopacity != null ? overrideopacity : 1,
    overflowWrap: 'anywhere',
  })
);

const Message = ({
  nickName,
  message,
  isMine,
  isModerator = false,
  isModerated = false,
  youTranslation,
  onDelete,
  i18n,
  messageTime,
  isVip,
  isMobile,
}) => {
  const { parseFromPubnubTimeToken } = useDataHelper();

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(i18n.moderator.deleteMessage);
      //console.log('DELETE RESPONSE:: ', res);
    }
  };

  return (
    <MainContainer>
      {isMine ? <Filler /> : null}
      <MessageContainer
        style={{
          backgroundColor: isMine ? theme.colors.primary.red : 'white',
          position: 'relative',
          padding: 16,
        }}
        ismobile={isMobile ? 1 : 0}
      >
        <SdmTypography
          margin={0}
          style={{
            fontSize: '0.750rem',
            fontFamily: 'Suisse-Intl',
            position: 'absolute',
            right: 16,
            bottom: 8,
            paddingTop: 3,
            marginLeft: 0,
            marginBottom: 0,
            marginTop: 5,
            color: isMine ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.7)',
          }}
        >
          {format(parseFromPubnubTimeToken(messageTime), 'HH:mm')}
        </SdmTypography>
        {!isMine && isVip ? (
          <div
            style={{
              width: 40,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <StarIcon
              style={{
                color: '#FFD700',
                marginLeft: 10,
              }}
              fontSize={'large'}
            />
          </div>
        ) : null}
        {isMine ? <Filler /> : null}
        <InnerContainer>
          <MessageTextContainer paddingleft={0}>
            <div
              style={{
                width: '100%',
                textAlign: 'right',
                display: 'flex',
                justifyContent:
                  !isMine && isModerator ? 'space-between' : 'flex-start',
              }}
            >
              <MessageTypography
                externalmargin={0}
                margin={0}
                style={{
                  color: isMine ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.7)',
                }}
              >
                {isMine ? youTranslation : nickName}
              </MessageTypography>
              {!isMine && isModerator ? (
                <Tooltip
                  title={
                    isModerated
                      ? i18n.moderator.buttons.moderated
                      : i18n.moderator.buttons.delete
                  }
                >
                  <div>
                    <SdmIconButtonLoader
                      style={{
                        cursor: isModerated ? 'arrow' : 'pointer',
                        color: isModerated ? theme.colors.primary.red : 'white',
                      }}
                      callback={isModerated ? null : handleDelete}
                      loaderStyle={{ height: 30, width: 30 }}
                    >
                      {isModerated ? (
                        <SecurityIcon
                          style={{
                            color: theme.colors.primary.red,
                            height: 14,
                            width: 14,
                            marginTop: 5,
                          }}
                        />
                      ) : (
                        <CloseIcon
                          //disabled={isModerated}
                          style={{
                            height: 14,
                            width: 14,
                            border: `1px solid ${theme.colors.primary.red}`,
                            borderRadius: '100%',
                            color: isModerated
                              ? 'black'
                              : theme.colors.primary.red,
                          }}
                        />
                      )}
                    </SdmIconButtonLoader>
                  </div>
                </Tooltip>
              ) : null}
            </div>
            <div style={{ display: 'flex' }}>
              <MessageTypography
                margin={0}
                externalmargin={'0 0 16px 0'}
                style={{
                  color: isModerated
                    ? isMine
                      ? 'white'
                      : theme.colors.primary.red
                    : isMine
                    ? 'white'
                    : 'black',
                }}
                textAlign={'left'}
              >
                {message}
              </MessageTypography>
            </div>
          </MessageTextContainer>
        </InnerContainer>
        {!isMine ? <Filler /> : null}
      </MessageContainer>
    </MainContainer>
  );
};

export { Message };
